<app-floorplan-item-details [floorplanItem]="zone">
  <div data-main>
    @if (zoneSizeForm) {
      <form
        odxForm
        [formGroup]="zoneSizeForm"
        [readonly]="
          (isReferenceMeasureSet$ | async) === false ||
          (isReadOnlyUser$ | async) === true ||
          (hasWritePermission$ | async) === false ||
          zone.locked
        "
      >
        <odx-form-field i18n-label="@@floorplan.details.form.item.name.widthInMeter" label="Breite (Meter)">
          <input
            formControlName="referenceWidth"
            min="0.1"
            step="1"
            type="number"
            odxFormFieldControl
            i18n-placeholder="@@floorplan.details.form.width.unit.meter"
            placeholder="Breite"
            [odxTooltip]="tooltipTextNoReferenceMeasure"
            [odxTooltipDisabled]="(isReferenceMeasureSet$ | async) === true"
          />
        </odx-form-field>
        <odx-form-field i18n-label="@@floorplan.details.form.item.name.heightInMeter" label="Höhe (Meter)">
          <input
            type="number"
            formControlName="referenceHeight"
            min="0.1"
            step="1"
            odxFormFieldControl
            i18n-placeholder="@@floorplan.details.form.height.unit.meter"
            placeholder="Höhe"
            [odxTooltip]="tooltipTextNoReferenceMeasure"
            [odxTooltipDisabled]="(isReferenceMeasureSet$ | async) === true"
          />
        </odx-form-field>
      </form>
    }
  </div>
</app-floorplan-item-details>
